<script lang="ts">import { getMenuItems } from "./data/menuItems";
import MenuItem from "./parts/menu-item.svelte";
import { stateFeatureSet, stateUi } from "@infinitro/config";
import { isFullScreenGame, isMobile, loggedIn, selectedItemMobileMenu } from "@infinitro/global";
import { onMount } from "svelte";
import CentralMenuItem from "./parts/central-menu-item.svelte";
export let onClickMenu = () => null;
export let onClickChat = () => null;
export let onClickSearch = () => null;
onMount(() => {
	const preventScroll = (event) => {
		const targetElement = event.target;
		if (targetElement.closest(".mobile-menu")) {
			event.preventDefault();
		}
	};
	document.addEventListener("touchmove", preventScroll, { passive: false });
	document.addEventListener("wheel", preventScroll, { passive: false });
	return () => {
		document.removeEventListener("touchmove", preventScroll);
		document.removeEventListener("wheel", preventScroll);
	};
});
$: useAlternative = $stateUi.mobileMenu.mobileMenuStyle === "alternative";
$: useAlternative2 = $stateUi.mobileMenu.mobileMenuStyle === "alternative2";
$: showFullScreenOnChatSlot = $isMobile && $isFullScreenGame && $stateUi.games.showNavigationOnMobile;
$: isMobileMenuFullScreenMode = $isMobile && $isFullScreenGame && $stateUi.games.showNavigationOnMobile && $selectedItemMobileMenu === "chat";
$: useAlternative4 = $stateUi.mobileMenu.mobileMenuStyle === "alternative4";
$: showMobileMenu = !$isFullScreenGame || $isFullScreenGame && $stateUi.games.showNavigationOnMobile && !isMobileMenuFullScreenMode;
</script>

{#if showMobileMenu}
	<nav
		class:mobile-menu-alternative={useAlternative || useAlternative4}
		class:mobile-menu-alternative2={useAlternative2}
		class="mobile-menu"
	>
		{#each getMenuItems($stateFeatureSet, Boolean($loggedIn), showFullScreenOnChatSlot) as menuItem (menuItem.key)}
			<div
				class="mobile-menu-item"
				class:mobile-menu-item-alternative={useAlternative || useAlternative4}
				class:mobile-menu-item-central={menuItem.isCentralButton &&
					$stateUi.layout.useCentralButtonOnMobileMenu}
			>
				{#if menuItem.isCentralButton && $stateUi.layout.useCentralButtonOnMobileMenu}
					<CentralMenuItem
						{menuItem}
						{onClickMenu}
						{onClickChat}
						{onClickSearch}
						{showFullScreenOnChatSlot}
					/>
				{:else}
					<MenuItem
						{menuItem}
						{onClickMenu}
						{onClickChat}
						{onClickSearch}
						{showFullScreenOnChatSlot}
					/>
				{/if}
			</div>
		{/each}
	</nav>
{/if}

<style>
	.mobile-menu {
		position: fixed;
		bottom: 0px;
		left: 0px;
		right: 0px;
		border-top-left-radius: 0.5rem;
		border-top-right-radius: 0.5rem;
		border-top-width: 1px;
		border-color: var(--color-neutral-900);
		--tw-bg-opacity: 1;
		--tw-backdrop-blur: blur(50px);
		backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
		background: var(--gradient-main);
		z-index: 55;
		height: 60px;
		width: 100vw;
		padding-left: 0px;
		padding-right: 0px;
		padding-bottom: 0.25rem;
		display: flex;
		align-items: center;
		justify-content: space-between
}
	@media (min-width: 1024px) {
		.mobile-menu {
				display: none
		}
}

	.mobile-menu-alternative {
		border-radius: 0px;
		border-top-width: 0px;
		background: var(--color-background-500)
}
	.mobile-menu-alternative2 {
		border-top-left-radius: 0px;
		border-top-right-radius: 0px;
		border-style: none;
		--tw-shadow: 0 0 #0000;
		--tw-shadow-colored: 0 0 #0000;
		box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
		--tw-backdrop-blur: blur(30px);
		backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
		background: linear-gradient(
			180deg,
			rgba(var(--color-background-700-rgb) / 0.5) 0%,
			rgba(var(--color-background-900-rgb) / 0.5) 100%
		) !important;
		overflow: visible
}

	.mobile-menu-item {
		display: flex;
		width: 20%;
		flex-direction: column;
		align-items: center;
		justify-content: center
}
	.mobile-menu-item-alternative {
		height: 75%;
		justify-content: flex-end
}

	.mobile-menu-item-central {
		position: relative;
		z-index: 10;
		overflow: visible
}

	.none {
		display: none
}
</style>
